import { render, staticRenderFns } from "./edit-customer-systemcode.vue?vue&type=template&id=2f07e5a0"
import script from "./edit-customer-systemcode.vue?vue&type=script&lang=ts"
export * from "./edit-customer-systemcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports